// @ts-check
import axios from 'axios';

/** @typedef {import('axios').AxiosRequestConfig} AxiosRequestConfig */
/** @typedef {import('./schema').operations} Operations */
/** @typedef {Operations['care_management_list_programs']['responses'][200]['content']['application/json']} CareManagementProgram[] */

/**
 * List care-management programs configured for the current tenant.
 *
 * @param {AxiosRequestConfig} [config]
 * @returns {Promise<CareManagementProgram[]>}
 */
export async function listCareManagementPrograms(config) {
  const { data } = await axios.get('/api/care-management/programs/', config);
  return data;
}

/** @typedef {import('./schema').components['schemas']['Metric']} Metric */
/** @typedef {import('./schema').components['schemas']['ProgramSettings']} ProgramSettings */

/**
 * GET /api/care-management/program-settings/ — each program's settings and the default they fall back to. Admin only.
 *
 * @returns {Promise<ProgramSettings>}
 */
export async function getProgramSettings() {
  const { data } = await axios.get('/api/care-management/program-settings/');
  return data;
}

/**
 * PATCH /api/metrics/{id}/ — set the subject prefilled when sending this program's engagement summaries to a provider.
 * Placeholders: {patient_name}, {program_name}. Blank uses the default subject. Admin only.
 *
 * @param {number} programId
 * @param {string} subject
 * @returns {Promise<Metric>}
 */
export async function updateProgramSummarySubject(programId, subject) {
  const { data } = await axios.patch(`/api/metrics/${programId}/`, { direct_message_subject: subject });
  return data;
}
